export interface GossipItem {
  id: string;
  title: string;
  desc: string;
  category: string;
  tag: string;
  heat: number;
  comments: number;
  online: number;
  image: string;
  alt: string;
  author: string;
  time: string;
}

export interface RankItem {
  id: number;
  title: string;
  category: string;
  heat: number;
  trend: "up" | "down" | "flat";
  online: number;
}

export interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
  chip: string;
}

export interface VoiceItem {
  id: number;
  nickname: string;
  tag: string;
  content: string;
  likes: number;
  replies: number;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const brandName = "吃瓜m";

export const navLinks = [
  { key: "feed", label: "现场围观", href: "#feed" },
  { key: "rank", label: "热瓜榜单", href: "#rank" },
  { key: "play", label: "玩法唠嗑", href: "#play" },
  { key: "voices", label: "瓜友评论", href: "#voices" },
  { key: "faq", label: "常见问题", href: "#faq" },
];

export const categories = ["明星八卦", "综艺现场", "网络热梗", "生活趣事", "社会热点"];

export const heroImage =
  "https://readdy.ai/api/search-image?query=warm%20cream%20background%20stylized%20editorial%20illustration%20of%20a%20lively%20online%20gossip%20gathering%20with%20many%20cute%20watermelon%20slice%20icons%20floating%20round%20speech%20bubbles%20and%20small%20chat%20hearts%20arranged%20playfully%20coral%20red%20and%20fresh%20leaf%20green%20flat%20vector%20palette%20with%20soft%20rounded%20modern%20shapes%20energetic%20youthful%20community%20energy%20minimalist%20harmonious%20layout%20with%20generous%20whitespace%20and%20gentle%20film%20grain&width=1600&height=900&seq=chi-gua-hero-2026&orientation=landscape";

export const gossipList: GossipItem[] = [
  {
    id: "g1",
    title: "新综艺首期花絮流出，嘉宾互动比正片还精彩",
    desc: "后台抢麦、临场整活、即兴接梗……网友直呼这段正片应该放出来，评论区已经开始疯狂押注下一期谁会出圈。",
    category: "明星八卦",
    tag: "热",
    heat: 12.8,
    comments: 3021,
    online: 1860,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20flat%20vector%20illustration%20with%20coral%20red%20and%20fresh%20leaf%20green%20palette%20soft%20rounded%20shapes%20playful%20watermelon%20gossip%20theme%20featuring%20a%20golden%20stage%20spotlight%20with%20a%20single%20microphone%20at%20center%20stage%20surrounded%20by%20floating%20star%20sparkles%20and%20small%20speech%20bubbles%20backstage%20entertainment%20chatter%20mood&width=800&height=600&seq=chi-gua-g1&orientation=squarish",
    alt: "综艺首期后台花絮流出 明星八卦现场围观",
    author: "小瓜锤锤",
    time: "2 分钟前",
  },
  {
    id: "g2",
    title: "宝藏演员片场日常被挖出，这届瓜友真能找",
    desc: "从开机到杀青的真实花絮拼图，一段冷门采访里的暖心小事刷屏，围观群众表示：粉了，粉了。",
    category: "明星八卦",
    tag: "新",
    heat: 9.6,
    comments: 1876,
    online: 1240,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20flat%20vector%20illustration%20with%20coral%20red%20and%20fresh%20leaf%20green%20soft%20rounded%20shapes%20watermelon%20gossip%20theme%20showing%20a%20cozy%20studio%20couch%20with%20two%20steaming%20coffee%20cups%20and%20floating%20round%20speech%20bubbles%20about%20favorite%20actors%20everyday%20film%20set%20moments%20calm%20and%20heartwarming%20energy&width=800&height=600&seq=chi-gua-g2&orientation=squarish",
    alt: "宝藏演员片场日常 网友考古围观",
    author: "吃瓜不加班",
    time: "8 分钟前",
  },
  {
    id: "g3",
    title: "爆款音综神仙翻唱出圈，评论区直接吵翻",
    desc: "同一首歌两版唱法各有一票拥趸，'谁更好听'的话题一路冲上热榜，瓜友们已经开启了循环对比模式。",
    category: "综艺现场",
    tag: "火",
    heat: 15.4,
    comments: 4580,
    online: 3420,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20flat%20vector%20illustration%20with%20coral%20red%20and%20fresh%20leaf%20green%20soft%20rounded%20shapes%20watermelon%20gossip%20theme%20featuring%20a%20small%20music%20stage%20with%20glowing%20speakers%20and%20floating%20musical%20notes%20and%20a%20spinning%20record%20disc%20with%20youthful%20vibrant%20festive%20energy&width=800&height=600&seq=chi-gua-g3&orientation=squarish",
    alt: "音综神仙翻唱出圈 综艺现场热议",
    author: "今天也在追更",
    time: "13 分钟前",
  },
  {
    id: "g4",
    title: "'今天我吃瓜'热梗爆火，年轻人都这样整活",
    desc: "从一句口癖到全网玩梗，有人把它做成表情包，有人拍起了小剧场，热梗背后的情绪共鸣成了最佳下饭话题。",
    category: "网络热梗",
    tag: "梗",
    heat: 11.2,
    comments: 2456,
    online: 1980,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20flat%20vector%20illustration%20with%20coral%20red%20and%20fresh%20leaf%20green%20soft%20rounded%20shapes%20watermelon%20gossip%20theme%20featuring%20one%20huge%20cute%20smiling%20watermelon%20with%20big%20eyes%20surrounded%20by%20tiny%20cheering%20characters%20and%20floating%20hashtag%20and%20speech%20bubbles%20playful%20meme%20energy&width=800&height=600&seq=chi-gua-g4&orientation=squarish",
    alt: "今天我吃瓜热梗爆火 网络热梗整活",
    author: "梗王在逃",
    time: "21 分钟前",
  },
  {
    id: "g5",
    title: "小区楼下巨型西瓜派对？画面也太治愈了",
    desc: "邻居们把'吃瓜'玩成了字面意思，巨型西瓜切开分给大家，围观网友表示：这才是理想的周末打开方式。",
    category: "生活趣事",
    tag: "暖",
    heat: 8.9,
    comments: 1320,
    online: 960,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20flat%20vector%20illustration%20with%20coral%20red%20and%20fresh%20leaf%20green%20soft%20rounded%20shapes%20watermelon%20gossip%20theme%20showing%20a%20small%20sunny%20neighborhood%20corner%20where%20people%20gather%20around%20a%20giant%20picnic%20watermelon%20laughing%20together%20cozy%20warm%20community%20wholesome%20mood&width=800&height=600&seq=chi-gua-g5&orientation=squarish",
    alt: "小区巨型西瓜派对 生活趣事治愈画面",
    author: "楼下那棵荔枝树",
    time: "30 分钟前",
  },
  {
    id: "g6",
    title: "全民围观！这场话题直播讨论量一夜破亿",
    desc: "从发起到发酵不到二十四小时，无数瓜友涌入评论区实时跟聊，大家一边围观一边为观点站队。",
    category: "社会热点",
    tag: "爆",
    heat: 18.6,
    comments: 6120,
    online: 5100,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20flat%20vector%20illustration%20with%20coral%20red%20and%20fresh%20leaf%20green%20soft%20rounded%20shapes%20watermelon%20gossip%20theme%20featuring%20a%20city%20plaza%20crowd%20watching%20a%20large%20outdoor%20screen%20with%20an%20upward%20trending%20arrow%20and%20floating%20live%20chat%20icons%20energetic%20public%20discussion%20buzz&width=800&height=600&seq=chi-gua-g6&orientation=squarish",
    alt: "话题直播讨论破亿 社会热点全民围观",
    author: "早八晚五吃瓜人",
    time: "41 分钟前",
  },
  {
    id: "g7",
    title: "暑期档新剧片单曝光，网友开始押宝下一部爆款",
    desc: "题材、阵容、档期一列出来，各路瓜友立刻分成'必追派'和'观望派'，押宝名单已经盖了上千楼。",
    category: "娱乐盘点",
    tag: "盘",
    heat: 10.3,
    comments: 2104,
    online: 1550,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20flat%20vector%20illustration%20with%20coral%20red%20and%20fresh%20leaf%20green%20soft%20rounded%20shapes%20watermelon%20gossip%20theme%20showing%20a%20clapperboard%20and%20play%20button%20beside%20a%20box%20of%20popcorn%20and%20sparkling%20stars%20suggesting%20upcoming%20dramas%20and%20excited%20anticipation%20mood&width=800&height=600&seq=chi-gua-g7&orientation=squarish",
    alt: "暑期档新剧片单曝光 爆款押宝围观",
    author: "片单收集器",
    time: "1 小时前",
  },
  {
    id: "g8",
    title: "全新竞技综艺上线，导师评价成热议焦点",
    desc: "点评犀利程度直接决定评论区走向，有人拍手叫好有人替选手鸣不平，现场火力值一路走高。",
    category: "综艺现场",
    tag: "竞",
    heat: 13.1,
    comments: 3520,
    online: 2870,
    image:
      "https://readdy.ai/api/search-image?query=warm%20cream%20editorial%20flat%20vector%20illustration%20with%20coral%20red%20and%20fresh%20leaf%20green%20soft%20rounded%20shapes%20watermelon%20gossip%20theme%20featuring%20a%20judging%20table%20with%20three%20microphones%20and%20a%20bright%20stage%20spotlight%20over%20a%20performer%20silhouette%20competitive%20talent%20show%20tension&width=800&height=600&seq=chi-gua-g8&orientation=squarish",
    alt: "竞技综艺导师评价 综艺现场热议",
    author: "围观使徒",
    time: "1 小时前",
  },
];

export const rankList: RankItem[] = [
  { id: 1, title: "全民围观！这场话题直播讨论量一夜破亿", category: "社会热点", heat: 18.6, trend: "up", online: 5100 },
  { id: 2, title: "爆款音综神仙翻唱出圈，评论区直接吵翻", category: "综艺现场", heat: 15.4, trend: "up", online: 3420 },
  { id: 3, title: "新综艺首期花絮流出，嘉宾互动比正片还精彩", category: "明星八卦", heat: 12.8, trend: "flat", online: 1860 },
  { id: 4, title: "'今天我吃瓜'热梗爆火，年轻人都这样整活", category: "网络热梗", heat: 11.2, trend: "up", online: 1980 },
  { id: 5, title: "全新竞技综艺上线，导师评价成热议焦点", category: "综艺现场", heat: 13.1, trend: "down", online: 2870 },
  { id: 6, title: "暑期档新剧片单曝光，网友开始押宝下一部爆款", category: "娱乐盘点", heat: 10.3, trend: "flat", online: 1550 },
];

export const featureList: FeatureItem[] = [
  {
    icon: "ri-eye-line",
    title: "在线围观",
    desc: "实时看到正在热议的瓜，围观人数、讨论走势一目了然，热瓜不落地，随时跟上节奏。",
    chip: "实时跟进",
  },
  {
    icon: "ri-chat-3-line",
    title: "评论区见",
    desc: "每条热瓜都有开放的评论区，发表观点、顶帖盖楼、互相回复，把话说给同频的瓜友听。",
    chip: "畅所欲言",
  },
  {
    icon: "ri-wechat-2-line",
    title: "聊瓜唠嗑",
    desc: "想边吃边聊，随时随地开个话头，从综艺到日常，和陌生人也聊得来，越唠瓜越香。",
    chip: "随时开聊",
  },
  {
    icon: "ri-team-line",
    title: "瓜团讨论",
    desc: "按感兴趣的话题加入瓜团，找到志同道合的伙伴，围坐一起深挖前因后果，讨论更有深度。",
    chip: "结伴吃瓜",
  },
];

export const voiceList: VoiceItem[] = [
  {
    id: 1,
    nickname: "一杯冰西瓜",
    tag: "综艺同好",
    content:
      "在吃瓜m在线围观真的太爽了，刷到一个话题点进去，大家已经在评论区把前因后果盘清楚了，少走好多弯路。",
    likes: 1286,
    replies: 96,
  },
  {
    id: 2,
    nickname: "瓜田里的猹",
    tag: "深度考古",
    content:
      "最喜欢瓜团讨论，同一件事不同视角拆开看特别有意思，跟着大家的聊天线索，经常能发现被忽略的细节。",
    likes: 963,
    replies: 74,
  },
  {
    id: 3,
    nickname: "今晚早点睡",
    tag: "下班唠嗑",
    content:
      "白天累了一天，晚上来评论区见见瓜友聊聊日常，虽然是陌生人，但聊着聊着就觉得挺暖的。",
    likes: 1577,
    replies: 112,
  },
  {
    id: 4,
    nickname: "拒绝画饼",
    tag: "理性吃瓜",
    content:
      "评论区氛围比想象中好，大家有理有据不吵架，遇到跑偏的也有人及时提醒理性发言，这点我很喜欢。",
    likes: 842,
    replies: 51,
  },
];

export const faqList: FaqItem[] = [
  {
    q: "吃瓜m是什么平台？",
    a: "吃瓜m是一个主打在线围观与实时讨论的瓜友社区。你可以在现场围观栏目看到正在热议的话题，在评论区见发表观点，也能加入瓜团和聊瓜唠嗑，和同频的瓜友一起把话题聊透，越唠瓜越香。",
  },
  {
    q: "什么是'在线围观'？",
    a: "在线围观指的是实时跟看一条正在发酵的热瓜。进入现场围观后，你能看到围观人数、评论热度与讨论走势，边看大家的观点边决定要不要下场说两句，全程不冷场。",
  },
  {
    q: "'评论区见'要怎么玩？",
    a: "每条热瓜下方都设有开放评论区。你可以点赞顶帖支持认同的观点，也可以发表自己的看法并回复他人，热门评论会被置顶展示，方便后来者快速抓住讨论重点。",
  },
  {
    q: "'瓜团讨论'怎么加入？",
    a: "根据你感兴趣的话题（如综艺、明星、网络热梗、生活趣事等）找到对应瓜团即可加入，加入后可以在团内发帖、参与专题讨论，和兴趣相投的伙伴一起深入挖掘话题背后的来龙去脉。",
  },
  {
    q: "发言需要注意什么？",
    a: "希望大家理性发言、友善交流，尊重每位嘉宾和网友。不造谣、不传谣，涉及他人隐私与未经证实的信息请谨慎对待，重要结论以权威渠道发布为准，共同维护干净热闹的吃瓜氛围。",
  },
  {
    q: "吃瓜m收费吗？",
    a: "目前在线围观、评论区互动、瓜团讨论等核心玩法均免费开放，可以放心体验。若未来推出增值会员服务，我们会在站内与公告中提前说明，绝不藏着掖着。",
  },
];